const googleApiKeyLookup = () =>
	(typeof import.meta !== 'undefined' &&
		import.meta.env?.REACT_APP_GOOGLE_MAPS_API_KEY) ||
	(typeof import.meta !== 'undefined' &&
		import.meta.env?.PUBLIC_GOOGLE_MAPS_API_KEY) ||
	(typeof process !== 'undefined' && process.env?.REACT_APP_GOOGLE_MAPS_API_KEY) ||
	(typeof window !== 'undefined' && window.REACT_APP_GOOGLE_MAPS_API_KEY) ||
	(typeof localStorage !== 'undefined' && localStorage.getItem('GOOGLE_MAPS_API_KEY')) ||
	'';

export default googleApiKeyLookup;
